import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useBackOfficeStore = defineStore(
    'back-office',
    () => {
        const selectedTenantSlug = ref<string | undefined>(undefined);
        const toolbarVisible = ref(false);

        const setSelectedTenantSlug = (slug: string | undefined) => {
            selectedTenantSlug.value = slug;
        };

        return {
            selectedTenantSlug,
            setSelectedTenantSlug,
            toolbarVisible,
        };
    },
    {
        persist: {
            storage: sessionStorage,
            pick: ['selectedTenantSlug', 'toolbarVisible'],
        },
    }
);
